import React from 'react';
import Slider from "react-slick";
import Lobjet from '../images/client-logos/logo-1.png';
import Sendfie from '../images/client-logos/logo-2.png';
import Fortuny from '../images/client-logos/logo-3.png';
import Versace from '../images/client-logos/logo-4.png';
import SpotPog from '../images/client-logos/logo-5.png';
import Yogasmoga from '../images/client-logos/logo-6.png';
import HollandSherry from '../images/client-logos/logo-7.png';
import Florists from '../images/client-logos/logo-8.png';
import UnitedBlue from '../images/client-logos/logo-9.png';
import EveryDoc from '../images/client-logos/logo-10.png';
import CUNY from '../images/client-logos/logo-11.png';
import CarDekho from '../images/client-logos/logo-12.png';
import Cardamom from '../images/client-logos/logo-13.png';
import Flowers from '../images/client-logos/logo-14.png';
import Mavi from '../images/client-logos/logo-15.png';
import Pearson from '../images/client-logos/logo-16.png';
import Ohio from '../images/client-logos/logo-17.png';
import HarryWinston from '../images/client-logos/logo-18.png';
import Columbia from '../images/client-logos/logo-19.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import '../styles/slick.scss';

const ClientLogosFooter = () =>{

    var settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 7,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive:[
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4, 
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2, 
                }
            }
        ]
    };    
    
    return (
        <Slider className="clients" {...settings}>
        {/*<ul className="clients" ref={client}>*/}
            <div><LazyLoadImage effect="blur" src={Lobjet} alt="L'OBJET" className="client" /></div>
            <div><LazyLoadImage effect="blur" src={Sendfie} alt="Sendfie"  className="client"/></div>
            <div><LazyLoadImage effect="blur" src={Fortuny} alt="Fortuny"  className="client"/></div>
            <div><LazyLoadImage effect="blur" src={Versace} alt="Versace"  className="client"/></div>
            <div><LazyLoadImage effect="blur" src={SpotPog} alt="SpotPog" className="client"/></div>
            <div><LazyLoadImage effect="blur" src={Yogasmoga} alt="Yogasmoga" className="client"/></div>
            <div><LazyLoadImage effect="blur" src={HollandSherry} alt="Holland & Sherry" className="client"/></div>
            <div><LazyLoadImage effect="blur" src={Florists} alt="Florists" className="client"/></div>
            <div><LazyLoadImage effect="blur" src={UnitedBlue} alt="United By Blue" className="client"/></div>
            <div><LazyLoadImage effect="blur" src={EveryDoc} alt="EveryDoc" className="client"/></div>
            <div><LazyLoadImage effect="blur" src={CUNY} alt="CUNY" className="client"/></div>
            <div><LazyLoadImage effect="blur" src={CarDekho} alt="CarDekho" className="client"/></div>
            <div><LazyLoadImage effect="blur" src={Cardamom} alt="Cardamom" className="client"/></div>
            <div><LazyLoadImage effect="blur" src={Flowers} alt="1800Flowers" className="client"/></div>
            <div><LazyLoadImage effect="blur" src={Mavi} alt="Mavi Jeans" className="client"/></div>
            <div><LazyLoadImage effect="blur" src={Pearson} alt="Pearson" className="client"/></div>
            <div><LazyLoadImage effect="blur" src={Ohio} alt="Ohio University" className="client"/></div>
            <div><LazyLoadImage effect="blur" src={HarryWinston} alt="harry Winston" className="client"/></div>
            <div><LazyLoadImage effect="blur" src={Columbia} alt="Columbia university" className="client"/></div>
        {/*</ul>*/}
        </Slider>
    )
}

export default ClientLogosFooter;